export default __webpack_public_path__ + "static/OptimaNovaLTProLight-12b318cd7267ec99421a281662a2f07c.otf";